import './styles/global.css'
import { hydrateStorage } from './core/persist'

/**
 * HYDRATE BEFORE IMPORTING THE APP, while the store does not yet exist.
 *
 * `store.ts` restores the last exploration synchronously while its module
 * evaluates, by decision: an async restore races the first-run demo, and both
 * orderings of that race are wrong. The documents live in IndexedDB, which can
 * only be read asynchronously. So the mirror `core/docStore.ts` keeps of the
 * shelf is filled HERE, before the store module is imported at all, and every
 * read from then on is a read of memory. The dynamic import is the whole
 * mechanism: a static `import './boot'` would be hoisted above this line and
 * evaluate the store on an empty mirror.
 *
 * The deferred boot then installs the committed-write queue before rendering.
 * `persist.ts` reaches neither the store nor anything that reads it, which is
 * what makes importing it up here safe — the same one-directional layering
 * `core/models.ts` is written around.
 */
const openingRoot = document.getElementById('root')
if (!openingRoot) throw new Error('Missing #root')
openingRoot.textContent = 'Opening your explorations…'

await hydrateStorage()
await import('./boot')
